/** Short modified date for upload list metadata (e.g. "7 Jun"). */
export function formatAssetModifiedDate(timestampMs: number): string {
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
  }).format(new Date(timestampMs));
}
